module.exports = __webpack_public_path__ + "static/1284370009.7f2bc8a3.jpg";